import { DreamElementOrText } from '@/sharedComponents/TextEditor/plate';
import { ITemplate, TEMPLATE_TYPE } from '@typedream/data';
import { Path } from 'slate';
import { createMachine } from 'xstate';

type SectionTemplatesContentContext = {
  /** Only used as reference for the current hovered template */
  hoveredTemplate?: ITemplate<TEMPLATE_TYPE.SECTION> | null;

  /** Will be used as the payload for processing template before usage */
  hoveredTemplatePreviewNode?: DreamElementOrText;

  /** Will be used as the rendered node in the editor */
  editorHoveredTemplatePreviewNode?: DreamElementOrText;

  hoveredTemplateMutator?: any;
  position?: Path;
};

export const sectionTemplatesContentMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QGUwGMAuBLA9gOwAIAVMAWwAcAbAQwzAIGF868MCBZatACyzzAB0ABQBOYAG5YwAd2JkqtMAGIA8gDkA+uxUBVZAFENAGX0BBAGr6A2gAYAuolDkcsLNnyOQAD0QA2ABwA7AI2gQCsNr6BAIwAnL4ALLEAzGEANCAAnohBAgBMCQm+vsk2yYURYWEAvtUZqJi4hCQUNHSMzGCsHFy8-MJikjJyrYqqmgxGAJIMANIaRPrsQkami7YOSCDOru54nj4IqQJB0Un+0WH+xf55eRnZCIHJwb7xgYF5cfF5YXm19XQexGCnaTFYXTYnB4fEEogkUlkLVBggY3HQAGsCFgAGYEOijdrcaiwAjkACuACNKFhYOiIAQ0J1WEoNp4dm4mgdEC9-AI-iUwvFYtdQvcsogwr4wgIEoFQtEvmVYrFfgCQA1gci2vRwSwob1YQJTBAGRh0fj5Dr8Th8RbIG4cCIBjg0HBSeb6ASUUoIPhBHxxDgMYJNU0Qda9ZCejD+iazRbvdaMLbPQQHSnnaJXe67V6rYoEIHXbQmhs2VsOXtuQg8mUBIlok3ArFwjZm+kJQhFclkgJe3lVXF-LFoiVYuqw-gI4oOhDutC+oJ43nLYSvan7RBHVmRDnYB7EwW6EowCI987QTinaQBFPmsfdcyDbHl6bV0nZynVxmnS63QeH6PkWeBBmgpb4OW9jsi4nIeFshwlHyfxtr40TtoULwPIgsRhH2yR5EEtwEYEtz+JOQLhtqs5Rguhpxu+aafu035pr+zoAEpwGAGDYHgUCMuS57RtwODiGekBrj6FZOLB1YIYgBQCHEpQJOhZyETEBHYQgKqxP2gQJGE4R5MksQJL8E51BqlHTtRYLPjGS4CFMECUMo6gaAAEiolgcQsSwrGs1jQZWclcgp3bRH2BS3DYNhSqkET+DpXz6SqcQocZXzlMkFGNHZj5zvqTlGvCQxIo+Ahopi2J4sx9DEqSFLUrS9KMs+rLRJssm7BFoCHDECT5DY-g2HKKTFMkFw6Xh0QCKRMR5MUcSGct+VakVtEvs55WIjOdACAAYjxPBSTqADkzVUjSdKSUy84YL6-oCMWIZ3rZD7rsV0aLmVgz7fZggnRgZ0NVdZI3W193PiBYEQXgUE9ds4XwQNiCfL4Jx1pE0QXE2pkJDpMRY2hBTttELb+EkgQbVRW2OX9-R7cMQPHad3DnYoEMtbd7UPfqp7nn+V43h9BVfSiP10a+AwIqzVUg2Dj481Dd0MgLkJwyWexIzBfVo94OSmQ2-hjdTrZhAkySUzpY3DfFATqU26FqbU1l4DgEBwJ494HU+j2lfw+twfskUALQm2NbxXCKxmKtcKVduHNiyqULxW9FgRIXK5HWX7QPSztRque5IfyejCAWTpIr9ncqrjRcyTjgkdOFd921B3CAMK+u5f9UbtZWwtbw2+E1tRKkRNdi8qflIOZsJPbFm9m3kuRoz9Hd-LlXrtV6JoFiuJc0SJKQ616sdY9-eG4cpR5CPKSU1bzfPFbs02A-byqsZUQFOENR86fX9kXLucsKr+zvKJWQDVsSEHYjfMOldyipzlARGw8Qxz+CFFUYm8V8gEQKEkUI1N2xrxAZ3Jmb4Ez5m+qxLcO5EE1kuH2CyvgvhqSKOZKIOl1KkzeIOAIP8VR50BBLChm9ZYriYkVeh9B2L-lzDIvuYUDZIMHnWeabCOFnDeEUQIvDXb9kwqNG2VxxqALEZtDukjnLSKPHQzc8jtyZgEFxWAPE+ICTQEJMQ3RRLiTEGaR8TDIocJCPFfRxFByKnFI8aKw8kJmVMi2SmtxyGF0oVvcBgNFYcxPmAVWF9+bPlCZXb+C1bhVFbL2VIQRZqthOKEJKERklVHdtUIAA */
    id: 'Section Template Content Machine',
    tsTypes: {} as import('./SectionTemplatesContent.fsm.typegen').Typegen0,
    context: {},
    initial: 'Idle',
    states: {
      Idle: {
        description: 'Waiting for the user to hover any template',

        on: {
          ON_HOVER_TEMPLATE: {
            target: 'Preview Template',
            actions: 'assignHoveredTemplate',
          },
        },
      },

      'Preview Template': {
        description: 'Insert the preview into the editor',

        on: {
          ON_MOUSE_LEAVE: {
            target: 'Idle',
            description: 'When the mouse leave the template, remove the preview from the editor.',
            actions: 'resetPreviewedTemplate',
          },
          ON_CLICK_TEMPLATE: {
            target: 'Add the template to the editor',
          },
        },

        states: {
          'Check if template has published content': {
            always: [
              {
                target: 'Show template in editor',
                cond: 'isPublishedContentExist',
              },
              "Fetch template's published content",
            ],
          },

          'Show template in editor': {
            entry: 'insertPreviewTemplateToEditor',
          },

          "Fetch template's published content": {
            invoke: {
              src: 'getPublicTemplateQuery',

              onDone: {
                target: 'Show template in editor',
                actions: 'assignHoveredTemplate',
              },

              onError: {
                target: 'Show template in editor',
                actions: 'assignErrorGetPublicTemplate',
              },
            },
          },
        },

        initial: 'Check if template has published content',
      },

      'Add the template to the editor': {
        initial: 'Process the template',

        states: {
          'Process the template': {
            invoke: {
              src: 'mutateProcessTemplateBeforeUsage',
              onDone: {
                target: 'Resetting current hovered template',
                actions: 'insertTemplateToEditor',
              },
              onError: '#Section Template Content Machine.Preview Template',
            },
          },

          'Resetting current hovered template': {
            always: '#Section Template Content Machine.Idle',
            entry: 'resetPreviewedTemplate',
          },
        },
      },
    },
    predictableActionArguments: true,
    preserveActionOrder: true,
    schema: {
      context: {} as SectionTemplatesContentContext,
      events: {} as
        | { type: 'ON_HOVER_TEMPLATE'; template: any }
        | { type: 'ON_MOUSE_LEAVE' }
        | { type: 'ON_CLICK_TEMPLATE' },
    },
  },
  {
    actions: {},
    services: {},
    guards: {
      isPublishedContentExist: (context, event) => {
        if (
          'published_content' in context?.hoveredTemplate &&
          context?.hoveredTemplate.published_content !== undefined &&
          context?.hoveredTemplate.published_content !== null
        ) {
          return true;
        }
        return false;
      },
    },
    delays: {},
  }
);
